
import axios from "../utils/axios";
import { getApiUrl } from "../helpers/common";
import { vmrsGet } from "./vmrsApi";

/**
 * Tìm ảnh qua core CBD: `REACT_APP_API_BASE_URL` + `/${REACT_APP_API_SERVICE_PREFIX}` (`/cbd/api/v1/search`), không qua VMRS
 * microservice (`vmrsPost`). Trang sau đi theo link `next` server trả về (explorearchive), nên cũng ở lại CBD.
 */
export async function search(payload: any)
{
  return axios.post(await getApiUrl(`/api/v1/search?provider_code=${payload?.provider_code}`), payload);
}

export async function getProvider(payload?: any)
{
  return vmrsGet(`/api/v1/providers`);
}


/**
 * Hãng cho màn Đặt chụp mới: BE lọc theo nhóm user (đặt chụp mới + loại ảnh được dùng).
 * Không dùng chung `getProvider` vì `allProviders` toàn cục còn dùng tra tên hãng ở đơn hàng / giỏ.
 */
export async function getTaskingProviders()
{
  return vmrsGet(`/api/v1/providers`, { params: { scope: "tasking" } });
}

/** Hãng cho màn ảnh có sẵn (giỏ hàng...): BE lọc theo nhóm user được dùng ảnh có sẵn. */
export async function getArchiveProviders()
{
  return vmrsGet(`/api/v1/providers`, { params: { scope: "archive" } });
}

export async function getImageTypes()
{

  // const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  // const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  // return axios.get(`${baseUrl}${withServicePrefix("/api/v1/configs/category/satellite_image_type?with_providers=true")}`);
  return vmrsGet("/api/v1/configs/category/satellite_image_type?with_providers=true")
}



export async function getFormSearchByImageType(payload?: any)
{

  // const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  // const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  // return axios.get(`${baseUrl}${withServicePrefix(`/api/v1/form-configs/search-form/key/${payload?.key}`)}`);
  return vmrsGet(`/api/v1/form-configs/search-form/key/${payload?.key}`)
}



